import { CurrencyOrEmpty } from '@plato/app-shared/components/currency-or-empty';
import { cn } from '@plato/ui/util/classes';

type MoneyDeltaBadgeProps = {
    children: number | undefined | null;
    className?: string;
};

export function MoneyDeltaBadge({ children, className }: MoneyDeltaBadgeProps) {
    const isPositive = children && children > 0 ? true : children && children < 0 ? false : null;

    return (
        <div
            className={cn(
                'flex shrink-0 flex-row items-center justify-center rounded-md',
                isPositive === true && 'text-green-600',
                isPositive === false && 'text-red-600',
                isPositive === null && 'text-neutral-600',
                className,
            )}
        >
            <CurrencyOrEmpty showPlusSignIfPositive>{children}</CurrencyOrEmpty>
        </div>
    );
}
